var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":_vm.openLink}},[_vm._v("\n    External Link "),_c('i',{staticClass:"fas fa-external-link-alt"})])
}
var staticRenderFns = []

export { render, staticRenderFns }